export default __webpack_public_path__ + "locales/sr-Latn-RS/ResetApplicationDialog.json?hash=b7c210790b12457efa3c8e25fe700f86";